export enum TelemetryTimings {
  ExpiredSessionIdTime = 1800000, // 30m
  RequestFrequency = 60000 // 1m
}
